import { render, staticRenderFns } from "./ProducerReview.vue?vue&type=template&id=3ea6f7d5&"
import script from "./ProducerReview.vue?vue&type=script&lang=js&"
export * from "./ProducerReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports